import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import Highcharts from 'highcharts';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { numberThousandsComma } from '@/utils/numberThousandsComma';
import { pieChartSettings, lineColumnChartSettings } from './chartSettings';
import { getPowerChartApi } from '@/api/energy';

import { mapState, mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
var SHOW_SWIPER_COUNT = 2;
var defaultDemandData = [{
  title: '即時用電功率',
  value: null,
  unit: 'kW'
}, {
  title: '本月累計用電量',
  value: null,
  unit: 'kWh'
}, {
  title: '上月累計用電量',
  value: null,
  unit: 'kWh'
}, {
  title: '今年累計',
  breakTitle: '用電碳排放量',
  value: null,
  unit: '公斤 CO2e / 度'
}
// {
//   title: 'RE 比例',
//   value: null,
//   unit: '%'
// }
];
export default {
  name: 'OverviewDemand',
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  props: {
    selectedFieldName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      SHOW_SWIPER_COUNT: SHOW_SWIPER_COUNT,
      datePickerOpen: false,
      selectedDateFormat: 'YYYY-MM-DD',
      dateFormatItems: [{
        label: '時',
        value: 'YYYY-MM-DD'
      }, {
        label: '日',
        value: 'YYYY-MM'
      }, {
        label: '月',
        value: 'YYYY'
      }, {
        label: '年',
        value: 'all'
      }],
      datepickerTypeList: {
        'YYYY-MM-DD': 'date',
        'YYYY-MM': 'month',
        YYYY: 'year'
      },
      dialog: false,
      selectedMeterLocation: [],
      selectedDate: [new Date(), new Date()],
      storageDate: [],
      // 若 open 會先清除 selectedDate, 用來暫存
      demandData: defaultDemandData,
      meterData: [],
      // 每分鐘資料 energyMinData
      pieChartOptions: _objectSpread(_objectSpread({}, pieChartSettings), {}, {
        series: [{
          name: '用電',
          data: [],
          // 根據 api data 填入
          dataLabels: {
            // enabled: true,
            format: '{point.y:.1f} %' // **確保小數點 1 位，整數不顯示 .0**
          }
        }]
      }),
      lineColumnChartOptions: _objectSpread(_objectSpread({}, lineColumnChartSettings), {}, {
        series: []
      }),
      // swiper
      swiperOption: {
        slidesPerView: SHOW_SWIPER_COUNT,
        slidesPerGroup: SHOW_SWIPER_COUNT,
        spaceBetween: 20,
        // grabCursor: true,
        // loop: true,
        // loopFillGroupWithBlank: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
          // hideOnClick: true
        }
        // breakpoints: {
        //   1024: {
        //     slidesPerView: 4,
        //     spaceBetween: 40
        //   },
        //   768: {
        //     slidesPerView: 3,
        //     spaceBetween: 30
        //   },
        //   640: {
        //     slidesPerView: 2,
        //     spaceBetween: 20
        //   },
        //   320: {
        //     slidesPerView: 1,
        //     spaceBetween: 10
        //   }
        // }
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('projectEnergy', ['energyMinData',
  // 'accPowerTodayData',
  'lastUpdateTime', 'co2ThisYear', 'reRationThisMon', 'allFieldInfoData', 'chartSummary'])), mapGetters('projectEnergy', ['getInstantPSum', 'getAccPowerThisMonSum', 'getAccPowerLastMonSum', 'getAccPowerThisMonPercentageData'])), {}, {
    // swiperOption () {
    //   return {
    //     slidesPerView: 3,
    //     slidesPerGroup: 3,
    //     spaceBetween: 20,
    //     // grabCursor: true,
    //     // loop: true,
    //     // loopFillGroupWithBlank: true,
    //     autoplay: {
    //       delay: 2500,
    //       disableOnInteraction: false
    //     },
    //     pagination: {
    //       el: '.swiper-pagination',
    //       clickable: true
    //       // hideOnClick: true
    //     }
    //     // breakpoints: {
    //     //   1024: {
    //     //     slidesPerView: 4,
    //     //     spaceBetween: 40
    //     //   },
    //     //   768: {
    //     //     slidesPerView: 3,
    //     //     spaceBetween: 30
    //     //   },
    //     //   640: {
    //     //     slidesPerView: 2,
    //     //     spaceBetween: 20
    //     //   },
    //     //   320: {
    //     //     slidesPerView: 1,
    //     //     spaceBetween: 10
    //     //   }
    //     // }
    //   }
    // },
    swiperWrapWidth: function swiperWrapWidth() {
      var _this$meterNameArr;
      var meterNum = ((_this$meterNameArr = this.meterNameArr) === null || _this$meterNameArr === void 0 ? void 0 : _this$meterNameArr.length) || 0;
      // 限制顯示 2 個, 超過會有滾輪
      return meterNum > SHOW_SWIPER_COUNT ? "".concat(SHOW_SWIPER_COUNT * 280 + (SHOW_SWIPER_COUNT - 1) * 20, "px") // card min-width 280px, 間距 20px
      : "".concat(meterNum * 280 + (meterNum - 1) * 20, "px");
    },
    meterNameArr: function meterNameArr() {
      var _this = this,
        _selectedInfo$;
      var selectedInfo = this.allFieldInfoData.filter(function (item) {
        return item.fieldName === _this.selectedFieldName;
      });
      var infoMeterMapping = (_selectedInfo$ = selectedInfo[0]) === null || _selectedInfo$ === void 0 ? void 0 : _selectedInfo$.meterMapping;
      var meterNameArr = infoMeterMapping === null || infoMeterMapping === void 0 ? void 0 : infoMeterMapping.map(function (item) {
        return item.meterName;
      });
      return meterNameArr;
    },
    meterLocationArr: function meterLocationArr() {
      var _this2 = this,
        _selectedInfo$2;
      var selectedInfo = this.allFieldInfoData.filter(function (item) {
        return item.fieldName === _this2.selectedFieldName;
      });
      var infoMeterMapping = (_selectedInfo$2 = selectedInfo[0]) === null || _selectedInfo$2 === void 0 ? void 0 : _selectedInfo$2.meterMapping;
      var meterLocationArr = infoMeterMapping === null || infoMeterMapping === void 0 ? void 0 : infoMeterMapping.map(function (item) {
        return item.meterLocation;
      });
      return meterLocationArr;
    },
    filteredMeterLocationArr: function filteredMeterLocationArr() {
      var _this3 = this;
      if (this.selectedMeterLocation.length) {
        return this.meterLocationArr.filter(function (item) {
          return _this3.selectedMeterLocation.includes(item);
        });
      }
      return this.meterLocationArr;
    },
    selectedDateToText: function selectedDateToText() {
      return [dayjs(this.selectedDate[0]).format(this.selectedDateFormat), dayjs(this.selectedDate[1]).format(this.selectedDateFormat)];
    } // 依照選擇給固定的 xAxis (ex 若未滿 24小時 仍顯示 24 小時)
    // xAxisArr () {
    //   const timeType = this.datepickerTypeList[this.selectedDateFormat]
    //   if (timeType) {
    //     switch (timeType) {
    //       case 'date':
    //         // 00:00, 01:00...
    //         return Array.from(
    //           { length: 24 },
    //           (_v, i) => String(i).padStart(2, '0') + ':00'
    //         )
    //       case 'month':
    //         // 2025-01-01, 2025-01-02...
    //         return Array.from(
    //           { length: dayjs(this.selectedDate).daysInMonth() },
    //           (_v, i) =>
    //             `${this.selectedDateToText}-` + String(i + 1).padStart(2, '0')
    //         )
    //       case 'year':
    //         // 2025-01, 2025-02...
    //         return Array.from(
    //           { length: 12 },
    //           (_v, i) =>
    //             `${this.selectedDateToText}-` + String(i + 1).padStart(2, '0')
    //         )
    //       default:
    //         return []
    //     }
    //   } else {
    //     return []
    //   }
    // }
  }),
  watch: {
    selectedFieldName: function selectedFieldName() {
      // 不用在 created 執行
      // 因與 index 一起渲染, index 取得 fieldName 後, 這裡會偵測執行 watch
      // 一開始 '' 到 call infos api 取得 fieldName

      this.selectedDateFormat = 'YYYY-MM-DD';
      this.selectedDate = [new Date(), new Date()];
      this.getApiDataAndSetChart();
    },
    energyMinData: function energyMinData() {
      this.setMeterData();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('projectEnergy', ['getLastDocData',
  // 'getAccPowerTodayData',
  'getAccPowerThisMonData', 'getAccPowerLastMonData', 'getCo2ThisYear', 'getReRatioThisMon'])), {}, {
    handleOpen: function handleOpen() {
      // 若先前有選擇日期, open 重新選擇時, 先清空並暫存於 storageDate
      if (this.selectedDate.length === 2) {
        this.storageDate = this.selectedDate;
        this.selectedDate = [];
      }
    },
    handleClose: function handleClose() {
      // 關閉時檢查是否有暫存, 若 pick 時有選擇2個日期, selectedDate 就不會為空
      if (this.selectedDate.length < 2 && this.storageDate.length === 2) {
        this.selectedDate = this.storageDate; // 暫存的放回去
        this.storageDate = []; // 清空暫存
      }
    },
    // 即時更新範圍
    handlePick: function handlePick(val) {
      if (!this.selectedDate[0]) {
        this.selectedDate[0] = val;
      } else {
        this.selectedDate[1] = val;
      }
    },
    disabledDate: function disabledDate(date) {
      // 取第一個選擇的起始值
      var start = this.selectedDate[0];
      var d = dayjs(date);
      var isFuture = d.isAfter(dayjs());
      if (!start) return isFuture;
      var base = dayjs(start);
      var isBeforeSelected = d.isBefore(base);
      if (this.datepickerTypeList[this.selectedDateFormat] === 'date') {
        // 限制 62 天(2個月)
        return isBeforeSelected || d.isAfter(base.add(61, 'day'), 'day') || isFuture;
      }
      if (this.datepickerTypeList[this.selectedDateFormat] === 'month') {
        // 限制 10 個月
        return isBeforeSelected || d.isAfter(base.add(9, 'month'), 'month') || isFuture;
      }
      if (this.datepickerTypeList[this.selectedDateFormat] === 'year') {
        // 限制 10 年
        return isBeforeSelected || d.isAfter(base.add(9, 'year'), 'year') || isFuture;
      }
      return isFuture; // 限制不能選未來日期
    },
    removeSelectedMeterLocation: function removeSelectedMeterLocation(item) {
      this.selectedMeterLocation = this.selectedMeterLocation.filter(function (i) {
        return i !== item;
      });
    },
    setDemandData: function setDemandData() {
      this.demandData = [{
        title: '即時用電功率',
        value: numberThousandsComma(this.getInstantPSum),
        unit: 'kW'
      }, {
        title: '本月累計用電量',
        value: numberThousandsComma(this.getAccPowerThisMonSum),
        unit: 'kWh'
      }, {
        title: '上月累計用電量',
        value: numberThousandsComma(this.getAccPowerLastMonSum),
        unit: 'kWh'
      }, {
        title: '今年累計',
        breakTitle: '用電碳排放量',
        value: numberThousandsComma(this.co2ThisYear),
        unit: '公斤 CO2e / 度'
      }
      // {
      //   title: 'RE 比例',
      //   value: this.reRationThisMon,
      //   unit: '%'
      // }
      ];
    },
    setMeterData: function setMeterData() {
      this.meterData = this.energyMinData;
    },
    setPieChart: function setPieChart() {
      this.pieChartOptions.subtitle.text = "<div style=\"margin-top:-65px;text-align:center;\">\n        <div style=\"margin-bottom:8px;\">\u7E3D\u7528\u96FB\u91CF</div><br>\n        <div style=\"font-size:32px;line-height:0px;\">".concat(this.getAccPowerThisMonSum, "<span style=\"font-size:16px;\"> \u5EA6</span></div>\n        </div>");
      this.pieChartOptions.series[0].data = this.getAccPowerThisMonPercentageData;
    },
    setLineColumnChart: function setLineColumnChart(data) {
      var _this4 = this;
      // 先清空, 要 push 新的
      this.lineColumnChartOptions.series = [];
      if (!(data !== null && data !== void 0 && data.length)) return;

      // xAxis
      // 選擇 '年', 直接用 data 的 date 去 map xAxisCategories
      // const isChooseYear = !this.xAxisArr.length
      // const xAxisCategories = isChooseYear
      //   ? data.map((o) => o.date)
      //   : this.xAxisArr

      // 若選擇 '時' 且選擇一天, 後端不會給日期 只會給時間
      var xAxisCategories = data.map(function (o) {
        return o.date;
      });
      // const isChooseHourAndOneDay =
      //   dayjs(this.selectedDate[0]).diff(dayjs(this.selectedDate[1]), 'day') ===
      //   0
      // const xAxisCategories = isChooseHourAndOneDay
      //   ? data.map((o) => o.date)
      //   : data.map((o) => {
      //     if (o.date.split(' ')[1] === '00:00:00') return o.date.split(' ')[0]
      //     return dayjs(o.date).format('HH:mm')
      //   })

      this.lineColumnChartOptions.xAxis.categories = xAxisCategories;

      // series
      this.meterNameArr.forEach(function (meterName, idx) {
        _this4.lineColumnChartOptions.series[idx] = {};
        _this4.lineColumnChartOptions.series[idx].name = meterName;
        _this4.lineColumnChartOptions.series[idx].data = data.map(function (o) {
          var _o$meters$idx;
          return Math.round(((_o$meters$idx = o.meters[idx]) === null || _o$meters$idx === void 0 ? void 0 : _o$meters$idx.power) * 100) / 100;
        });

        // 選擇 '年', 直接用 data 去 map series.data
        // this.lineColumnChartOptions.series[idx].data = isChooseYear
        //   ? data.map((o) => Math.round(o.meters[idx]?.power * 100) / 100)
        //   : xAxisCategories.map((d) => {
        //     const v = data.find((o) => o.date === d)?.meters[idx]?.power
        //     return isNumber(v) ? Math.round(v * 100) / 100 : null
        //   })
      });
    },
    observeElementSize: function observeElementSize() {
      // menu 開闔 -> viewRef 大小改變 -> Highcharts charts reflow
      this.resizeObserver = new ResizeObserver(function (_entries) {
        Highcharts.charts.forEach(function (chart) {
          if (chart && (chart.renderTo.id === 'pieChartId' || chart.renderTo.id === 'lineColumnChartId')) {
            chart.reflow();
          }
        });
      });
      this.resizeObserver.observe(this.$refs.viewRef);
    },
    clearDemandDataAndChart: function clearDemandDataAndChart() {
      this.demandData = defaultDemandData;
      this.meterData = [];
      this.lineColumnChartOptions.xAxis.categories = [];
      this.lineColumnChartOptions.series = [];
      this.pieChartOptions.subtitle.text = "<div style=\"margin-top:-40px;text-align:center;\">\n        <div style=\"margin-bottom:0px;\">\u7E3D\u7528\u96FB\u91CF</div><br>\n        <div style=\"font-size:32px;line-height:0px;\">-<span style=\"font-size:16px;\"> \u5EA6</span></div>\n        </div>";
      this.pieChartOptions.series[0].data = [];
    },
    handleChangeDateOrDateFormat: function handleChangeDateOrDateFormat(changeType, dateFormat) {
      if (changeType === 'changeDateFormat') {
        this.selectedDateFormat = dateFormat;
        this.selectedDate = [new Date(), new Date()];
        // this.SET_CHART_SUMMARY_IS_RESET(true)
      }
      this.getPowerChartData();
    },
    getPowerChartData: function getPowerChartData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res, convertedData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  fieldName: _this5.selectedFieldName,
                  startDate: _this5.selectedDateFormat === 'all' ? dayjs().subtract(9, 'year').format('YYYY') : _this5.selectedDateToText[0],
                  endDate: _this5.selectedDateFormat === 'all' ? dayjs().format('YYYY') : _this5.selectedDateToText[1],
                  isAll: _this5.selectedDateFormat === 'all'
                };
                _context.prev = 1;
                _context.next = 4;
                return getPowerChartApi(params);
              case 4:
                res = _context.sent;
                if (res.data.success && res.data.data) {
                  convertedData = _toConsumableArray(res.data.data).sort(function (a, b) {
                    return dayjs(a.date).valueOf() - dayjs(b.date).valueOf();
                  }).map(function (o) {
                    if (o.date.length === 19) {
                      return {
                        date: o.date.slice(0, 16),
                        meters: o.meters
                      };
                    }
                    return o;
                  });
                  _this5.setLineColumnChart(convertedData);
                } else if (res.data.msg === 'no data') {
                  _this5.lineColumnChartOptions.series = [];
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('getPowerChartData error', _context.t0);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    getApiDataAndSetChart: function getApiDataAndSetChart() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.clearDemandDataAndChart();

                // 用 energyMinData 跑 v-for, energyMinData 資料取得較慢, lineColumnChart 會先渲染導致圖表為 w-100 並跑 meters 到下方 -> await getLastDocData 確認先取得
                _context2.next = 3;
                return _this6.getLastDocData(_this6.selectedFieldName);
              case 3:
                // this.getAccPowerTodayData(this.selectedFieldName)
                _this6.getReRatioThisMon(_this6.selectedFieldName).then(function () {
                  _this6.setDemandData();
                });
                _this6.getPowerChartData();
                _this6.getAccPowerLastMonData(_this6.selectedFieldName);
                _this6.getCo2ThisYear(_this6.selectedFieldName);
                _context2.next = 9;
                return _this6.getAccPowerThisMonData(_this6.selectedFieldName).then(function () {
                  _this6.setPieChart();
                });
              case 9:
                // get 完資料後再 set
                _this6.setMeterData();

                // 根據案場 meter 數量判斷是否 顯示 swiper
                // 更新 Swiper 實例
                _this6.$nextTick(function () {
                  var _this6$meterNameArr;
                  if (((_this6$meterNameArr = _this6.meterNameArr) === null || _this6$meterNameArr === void 0 ? void 0 : _this6$meterNameArr.length) > SHOW_SWIPER_COUNT) {
                    _this6.$refs.mySwiper.$swiper.allowSlidePrev = true;
                    _this6.$refs.mySwiper.$swiper.allowSlideNext = true;
                  } else {
                    _this6.$refs.mySwiper.$swiper.allowSlidePrev = false;
                    _this6.$refs.mySwiper.$swiper.allowSlideNext = false;
                  }
                });
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }),
  mounted: function mounted() {
    // chart
    this.observeElementSize();
  },
  beforeDestroy: function beforeDestroy() {
    // chart
    this.resizeObserver.disconnect();
  }
};